
import React from 'react';
import { Label } from "@/components/ui/label";

interface JobDateFieldProps {
  label: string;
  dateString?: string;
  formatDate: (dateString?: string) => string;
}

export const JobDateField: React.FC<JobDateFieldProps> = ({ label, dateString, formatDate }) => {
  return (
    <div>
      <Label className="text-xs font-medium text-muted-foreground">{label}</Label>
      <p>{formatDate(dateString)}</p>
    </div>
  );
};
